<template>
  <div v-loading="loading" class="aligner">
    <el-row>
      <h4>{{$t('qrCodesTitle')}}</h4>
      <el-card style="max-width: 320px;text-align:center">
        <el-row>
          <a style="font-size: 12px" :href="qr" target="_blank">{{qr}}</a>
        </el-row>
        <hr />
        <el-row>
          <qr-code :text="qr" :src.sync="src"></qr-code>
        </el-row>
        <hr />
        <el-row style="font-size: 12px">{{ $t('copy_instr') }}</el-row>
        <el-row>
          <el-button :disabled="!qr" round type="primary" @click="print">{{ $t('print') }}</el-button>
          <el-button :disabled="!qr" round type="primary" @click="download">{{ $t('download') }}</el-button>
          <el-button :disabled="!qr" round type="primary" @click="copy">{{ $t('copy_link') }}</el-button>
        </el-row>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import print from 'print-js'
import copy from 'copy-to-clipboard'

export default {
  name: 'qrList',
  data() {
    return {
      items: [],
      qr: '',
      src: '',
      loading: true
    }
  },
  created() {
    apiRes.get(apiRes.qrUrl).then(res => {
    }).finally(() => { this.loading = false })
    this.loadQr()
  },
  methods: {
    loadQr() {
      this.loading = true
      apiRes.post(apiRes.qrUrl, {}, true).then(res => {
        this.qr = res.page_vars.link
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    print() {
      print(this.src, 'image')
    },
    download() {
      const downloadLink = document.createElement('a')
      downloadLink.href = this.src
      downloadLink.download = 'qr.png'
      downloadLink.click()
    },
    copy() {
      copy(this.qr)
      this.$notify.info({ message: this.$t('copied') })
    }
  }
}
</script>
